import angular from 'angular';
import loansSignUpModalComponent from './loansSignUpModal.component';

let loansSignUpModalModule = angular.module('loansSignUpModal', [
])

.component('loansSignUpModal', loansSignUpModalComponent)

.name;

export default loansSignUpModalModule;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/loansSignUp/loansSignUpModal/loansSignUpModal.js